<ion-header>
  <ion-toolbar>
    <ion-back-button slot="start" (click)="back()" text=""></ion-back-button>
    <ion-title *ngIf="isNew">Neuer Tag</ion-title>
    <ion-title *ngIf="!isNew">{{tag?.description}}</ion-title>
    <ion-buttons slot="end" *ngIf="!isNew">
      <ion-button slot="icon-only" style="box-shadow: none;" (click)="deleteTag()">
        <ion-icon name="fa-trash"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <h1 *ngIf="isNew">Neuer Tag</h1>
  <h1 *ngIf="!isNew">{{tag?.description}}</h1>
  
  <h2>Vorschau</h2>
  <div id="preview" [ngStyle]="{'background': tag.rgba, 'color': tag.hex}">
    {{tag?.description ? tag.description : "Bezeichnung"}}
  </div>
  
  <h2>Bezeichnung</h2>
  <input type="text" placeholder="Tag..." [(ngModel)]="tag.description">
  
  <h2>Farbe</h2>
  <div id="colors">
    <div *ngFor="let color of colors" class="color" [class.active]="tag?.hex == color" (click)="selectColor(color)" [ngStyle]="{'background': color}"></div>
    <div id="color-picker" (click)="openColorPicker()">
      <div [ngStyle]="{'background': tag.hex}">
        <label id="pickerLabel" for="colorPicker"></label>
        <input #picker id="colorPicker" type="color" (onChange)="changeCustomColor()">
      </div>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar class="ion-padding" style="padding-top: 0;">
    <div class="button main-button" (click)="save()">Speichern</div>
  </ion-toolbar>
</ion-footer>